import Cookies from "js-cookie";
import actions from "./actions";
import { GuestService } from "../../config/data/guestService";
import { DataService } from "../../config/data/dataService";
import { requestFirebaseMessagingToken } from "../../config/firebase";
const {
  initial,
  loginBegin,
  loginSuccess,
  loginErr,
  autoLoginBegin,
  autoLoginSuccess,
  autoLoginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  forgotBegin,
  forgotSuccess,
  forgotErr,
  otpBegin,
  otpSuccess,
  otpErr,
  changeBegin,
  changeSuccess,
  changeErr,
  checkStoreBegin,
  checkStoreSuccess,
  checkStoreErr,
} = actions;

const login = (data) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin());
      const fcmToken = await requestFirebaseMessagingToken().catch((error) => {
        console.warn("Firebase notification permission/token failed:", error);
        return null;
      });
      const response = await GuestService.post("/login", { ...data, fcm_token: fcmToken });
      if (response.status === 200 && response.data.status === true) {
        if (fcmToken) {
          localStorage.setItem("firebaseMessagingToken", fcmToken);
        } else {
          localStorage.removeItem("firebaseMessagingToken");
        }
        setTimeout(() => {
          Cookies.set("SangVendorLoggedIn", true);
          Cookies.set("SangVendorLoggedData", JSON.stringify(response.data));
          dispatch(loginSuccess(true, response.data));
        }, 0);
      } else {
        dispatch(loginErr(response.data.message));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const autoLogin = (token) => {
  return async (dispatch) => {
    try {
      dispatch(autoLoginBegin());
      const response = await GuestService.post("/autoLogin", { token });

      if (response.status === 200 && response.data.status === true) {
        Cookies.set("SangVendorLoggedIn", true);
        Cookies.set("SangVendorLoggedData", JSON.stringify(response.data));
        dispatch(autoLoginSuccess(true, response.data));
        return response.data;
      }

      dispatch(autoLoginErr(response.data?.message || "Auto login failed"));
      return response.data;
    } catch (err) {
      dispatch(autoLoginErr(err));
      throw err;
    }
  };
};

const sendOtpForgot = (data) => {
  return async (dispatch) => {
    try {
      dispatch(forgotBegin());
      const response = await GuestService.post("/sendForgotOTP", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(forgotSuccess(true, data.username));
      } else {
        dispatch(forgotErr(response.data.message));
      }
    } catch (err) {
      dispatch(forgotErr(err));
    }
  };
};

const verifyOtpForgot = (data) => {
  return async (dispatch) => {
    try {
      dispatch(otpBegin());
      const response = await GuestService.post("/sendVerifiedOTP", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(otpSuccess(true));
      } else {
        dispatch(otpErr(response.data.message));
      }
    } catch (err) {
      dispatch(otpErr(err));
    }
  };
};

const changePassword = (data) => {
  return async (dispatch) => {
    try {
      dispatch(changeBegin());
      const response = await DataService.post("/changePassword", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(changeSuccess(true));
      } else {
        dispatch(changeErr(response.data.message));
      }
    } catch (err) {
      dispatch(changeErr(err));
    }
  };
};

const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      await GuestService.delete("/logout")
        .then((response) => {
          if (response.data.status === true) {
            Cookies.remove("SangVendorLoggedIn");
            Cookies.remove("SangVendorLoggedData");
            localStorage.removeItem("firebaseMessagingToken");
            dispatch(logoutSuccess(true));
          }
        })
        .catch((error) => {
          dispatch(logoutErr(error));
        });
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const forgotInitialState = () => {
  return async (dispatch) => {
    dispatch(initial());
  };
};

const checkStorePermission = () => {
  return async (dispatch) => {
    try {
      dispatch(checkStoreBegin());

      const response = await DataService.post("/checkStore", {
        router: "about",
      });
      if (response?.status === 200 && response?.data) {
        const allowed =
          response.data.status === true && response.data.data === "allow";

        dispatch(checkStoreSuccess(allowed));
        return allowed;
      } else {
        dispatch(
          checkStoreErr(response?.data?.message || "Permission check failed")
        );
        return false;
      }
    } catch (err) {
      const errPayload = err?.response?.data || err?.message || err;
      dispatch(checkStoreErr(errPayload));
      return false;
    }
  };
};

export {
  login,
  autoLogin,
  logOut,
  sendOtpForgot,
  verifyOtpForgot,
  changePassword,
  forgotInitialState,
  checkStorePermission,
};
